import { ApiData, InsuranceName } from 'scenes/common/types';
import { makeApiSuccess } from 'scenes/common/helpers/apiData';

import {
  EstimatedSumInsuredProfile,
  EstimatedSumInsured,
  WireEstimatedSumInsuredRequest,
  WireEstimatedSumInsuredResponse,
} from './types';
import { requestDefaults, wireProduct } from '../marshaller';
import { WireStatus } from '../types';

export const marshalRequest = (
  insuranceName: InsuranceName,
  profile: EstimatedSumInsuredProfile
): WireEstimatedSumInsuredRequest => ({
  ...requestDefaults(wireProduct[insuranceName]),
  targetStatus: WireStatus.EstimateSumInsured,
  profile,
});

export const unmarshalResponse = (
  response: WireEstimatedSumInsuredResponse
): ApiData<EstimatedSumInsured> =>
  makeApiSuccess<EstimatedSumInsured>({
    estimatedValue: response?.payload?.buildingSumInsured?.estimatedValue,
    maxLimit: response?.payload?.buildingSumInsured?.maxLimit,
    minLimit: response?.payload?.buildingSumInsured?.minLimit,
  });
